import { render, staticRenderFns } from "./import_posts.vue?vue&type=template&id=2fb045da&scoped=true&"
import script from "./import_posts.vue?vue&type=script&lang=js&"
export * from "./import_posts.vue?vue&type=script&lang=js&"
import style0 from "./import_posts.vue?vue&type=style&index=0&id=2fb045da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb045da",
  null
  
)

export default component.exports